import { ViewportProps } from 'react-map-gl';
import {
  EventOffering_PassEdge as EventOffering,
  FacilityOffering,
} from '@pass-frontend/data-access/common/edge';

export const OFFERINGS_SLICE_NAME = 'offerings';

export interface OfferingsState {
  chosenGymID: FacilityOffering['facilityId'];
  chosenSocialEventID: EventOffering['eventId'];
  chosenPin: FacilityOffering['facilityId'] | null;
  mobileFilterDrawerForGymsIsOpen: boolean;
  mobileFilterDrawerForSocialEventsIsOpen: boolean;
  mapIsVisible: boolean;
  viewport: ViewportProps;
  viewportIsSearchArea: boolean;
  isSocialEventsTriggeredFromFitness: boolean;
  userPreferenceOfMap: boolean;
}

export interface OfferingsOwnState {
  [OFFERINGS_SLICE_NAME]: OfferingsState;
}
